export const DetalhesBriefing = ({ element }) => {
    return (
        <>
            {element.categoria && element.categoria === "Brindes"
                ? ` Descrição: ${element.descricao} 
                    | Público Alvo: ${element.publico_alvo} 
                    | Item de Marca: ${element.item_de_marca ? "Sim" : "Não"} `
                : element.categoria === "Material Impresso"
                    ? `Descrição: ${element.descricao} 
                    | Quantidade de páginas: ${element.quantidade_de_paginas} 
                    | Formato aberto: ${element.formato_aberto}cm 
                    | Formato fechado: ${element.formato_fechado}cm 
                    | Tipo de Papel: ${element.substrato} 
                    | Gramatura: ${element.gramatura} 
                    | Cores: ${element.cores} 
                    | Acabamentos: ${element.acabamentos} `
                    : element.categoria == "Ponto de Venda"
                        ? `Descrição: ${element.descricao} 
                        | Tamanho Final: ${element.tamanho} 
                        | Substrato: ${element.substrato} | Espessura: ${element.espessura} 
                        | Cores: ${element.cores} | Acabamentos: ${element.acabamentos} 
                        | Necessário Positivação: ${element.positivacao ? "Sim" : "Não"
                        } `
                        : element.categoria === "Comunicação Visual"
                            ? `Descrição: ${element.descricao} 
                            | Tamanho Final: ${element.tamanho} 
                            | Formato aberto: ${element.formato_aberto}cm 
                            | Substrato: ${element.substrato} 
                            | Gramatura: ${element.gramatura} 
                            | Cores: ${element.cores} 
                            | Acabamentos: ${element.acabamentos} 
                            | Necessário Positivação: ${element.positivacao ? "Sim" : "Não"}`
                            : ""}
        </>
    )
}